// @flow
import React from 'react';
import { useForm, Controller } from 'react-hook-form';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import Toggle from 'material-ui/Toggle';
import { calculateWeight, titleValidation } from '../../util/validation';

export const InfoStringForm = props => {
	const { onSubmit, children, initialValues } = props;

	const {
		control,
		formState: { isValid, errors },
		setValue,
		handleSubmit,
	} = useForm({
		mode: 'all',
		defaultValues: initialValues,
	});

	return (
		<form onSubmit={handleSubmit(onSubmit)}>
			<Controller
				name="title"
				control={control}
				rules={{
					required: true,
					validate: value => {
						return titleValidation(value) === null;
					},
				}}
				render={({ fieldState: { error }, field }) => (
					<React.Fragment>
						<TextField
							value={field.value}
							errorText={error ? 'Название заполнено неверно' : ''}
							onChange={field.onChange}
							floatingLabelText="Загловок"
							fullWidth
							floatingLabelFixed
						/>
						<small>Вес заголовка: {calculateWeight(field.value)}</small>
					</React.Fragment>
				)}
			/>
			<Controller
				name="order"
				control={control}
				rules={{ required: false, min: 1, max: 10, defaultValues: 1 }}
				render={({ fieldState: { error }, field }) => (
					<TextField
						value={field.value}
						type="number"
						errorText={error ? 'Порядок заполнен неверно' : ''}
						onChange={field.onChange}
						floatingLabelText="Порядок (оставить по умолчанию)"
						fullWidth
						floatingLabelFixed
					/>
				)}
			/>
			<div style={{ maxWidth: 255 }}>
				<Controller
					name="infostring"
					control={control}
					render={({ fieldState: { error }, field: { onChange, value } }) => (
						<Toggle
							style={{ marginBottom: 10 }}
							toggled={value}
							label="Отображать в бегущей строке"
							onToggle={(e, v) => {
								if (!v) {
									setValue('infostring_hot', false);
								}
								onChange(v);
							}}
						/>
					)}
				/>

				<Controller
					name="infostring_hot"
					control={control}
					render={({ fieldState: { error }, field: { onChange, value } }) => (
						<Toggle
							style={{ marginBottom: 10 }}
							toggled={value}
							label="Горячая новость"
							onToggle={(e, v) => {
								if (v) {
									setValue('infostring', true);
								}
								onChange(v);
							}}
						/>
					)}
				/>
			</div>

			<div style={{ display: 'flex', marginTop: 20 }}>
				<RaisedButton disabled={!isValid} label="Сохранить" type="submit" primary={true} />
				{children}
			</div>
		</form>
	);
};



// WEBPACK FOOTER //
// src/components/info-strings/InfoStringForm.js